import React, { useEffect, useRef, useState } from 'react';

import styles from './PickupPointItem.module.css'
import { Button } from "../../../../../../../ui/General/Button/Button.tsx";
import { cn } from "../../../../../../../utils/cn.ts";
import { arrowDownIcon, crossIcon } from "../../../../../../../assets/icons/icons.ts";
import { PickupPoint } from "./types/PickupPoint.interface.ts";
// import { useLocalStorage } from "../../../../../../../hooks/useLocalStorage.ts";
import { RootState } from '@/utils/storage/stores/store.ts';
import { useAppSelector } from '@/utils/storage/stores/store.ts';

interface Props {
    point: PickupPoint
    currentTownId: number | null,
    choosePickPoint: (point: PickupPoint) => void
    changeCheckedPickPoint: (point: PickupPoint) => void
}

export const PickupPointItem: React.FC<Props> = ({
    point,
    choosePickPoint,
    currentTownId,
    changeCheckedPickPoint,
}) => {
    // const  {getStorageValue} = useLocalStorage();
    // const currentUserBranchId = getStorageValue('currentBranchId');
    // const selectedPickPoint = getStorageValue('selectedPickPoint');
    const currentUserBranchId = useAppSelector((state: RootState) => state.user.userInfo?.branchId);
    const selectedPickPoint = useAppSelector((state: RootState) => state.user.selectedPickPoint);
    const isChecked = (point.id === currentUserBranchId);
    const selected = (point.id === selectedPickPoint);
    const [isOpen, setIsOpen] = useState<boolean>(false)

    // if(point.townId !== currentTownId && point.id !== 1) return null;

    const divRef = useRef<HTMLDivElement>(null);

    const scrollToBottom = () => {
        if (isChecked && divRef.current) divRef.current.scrollIntoView({ block: "end" });
    }

    useEffect(() => {
        if (isChecked) {
            scrollToBottom();
        }
    }, [isChecked]);

    return (
        <div className={cn(selected && styles.isChecked, styles.card)}>
            <div className={styles.header}>
                <input checked={isChecked} className={styles.checkbox} type='checkbox' onClick={() => changeCheckedPickPoint(point)} />
                <h3 className={styles.title}>
                    <div>{point.address}</div>
                    {point.type === '100sp' ? <div style={{ fontWeight: 'normal', }}>(доставка из Владивостока транспортной компанией 100СП)</div> : null}
                </h3>
            </div>
            <div className={styles.settings}>
                <Button
                    type='regular'
                    className={cn(selected ? styles.chosenBtn : styles.chooseBtn)}
                    onClick={() => {
                        choosePickPoint(point)
                    }}
                >
                    {selected ? 'Выбран' : 'Выбрать'}
                </Button>
                {currentTownId !== 1 && point.id === 1
                    ? null
                    : <div className={styles.descriptionBtn}>
                        {!isOpen && <img width={14} height={16} src={arrowDownIcon} alt='Открыть' />}
                        {isOpen && <img width={12} height={13} src={crossIcon} alt='Закрыть' />}
                        <Button type='text' onClick={() => setIsOpen(!isOpen)}>Подробнее</Button>
                    </div>
                }
            </div>
            {
                isOpen && (currentTownId === 1 || point.id !== 1)
                    ? (
                        <div className={styles.description}>
                            <div className={styles.pictures}>
                                {point.images.map((url) =>
                                    (<img src={url} style={{ width: '100%', }} />)
                                )}
                            </div>

                            <div className={styles.workingHours}>
                                <div className={styles.workingHoursTitle}>Режим работы:</div>
                                <div>{point.schedule}</div>
                            </div>

                            {
                                point.paymentTypes
                                    ? <div className={styles.paymentMethods}>
                                        <div className={styles.paymentMethodsTitle}>Способы оплаты:</div>
                                        <div>{point.paymentTypes}</div>
                                    </div>
                                    : null
                            }
                        </div>
                    ) : null}
            <div ref={divRef} style={{ position: 'absolute', bottom: -218, width: 0, height: 0 }}></div>
        </div>
    );
};